{
  "name": "@oracychampions/source",
  "version": "0.0.0",
  "license": "MIT",
  "scripts": {
    "serve": "nx run-many --target=serve --projects=client,server --configuration=development,development",
    "deploy": "npm run deploy:backend && npm run deploy:frontend",
    "deploy:backend": "./deploy/prod/scripts/deploy-backend.sh",
    "deploy:frontend": "./deploy/prod/scripts/deploy-frontend.sh && npm run sentry:sourcemaps",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org webanywhere --project oracychampions ./dist/apps/client && sentry-cli sourcemaps upload --org webanywhere --project oracychampions ./dist/apps/client"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~18.0.0",
    "@angular/cdk": "^18.0.4",
    "@angular/common": "~18.0.0",
    "@angular/compiler": "~18.0.0",
    "@angular/core": "~18.0.0",
    "@angular/forms": "~18.0.0",
    "@angular/platform-browser": "~18.0.0",
    "@angular/platform-browser-dynamic": "~18.0.0",
    "@angular/router": "~18.0.0",
    "@aws-sdk/client-cognito-identity-provider": "^3.600.0",
    "@aws-sdk/client-s3": "^3.600.0",
    "@aws-sdk/s3-request-presigner": "^3.609.0",
    "@nestjs-modules/mailer": "^2.0.2",
    "@nestjs/common": "^10.0.2",
    "@nestjs/config": "^3.2.2",
    "@nestjs/core": "^10.0.2",
    "@nestjs/platform-express": "^10.0.2",
    "@nestjs/swagger": "^7.3.1",
    "@nestjs/typeorm": "^10.0.2",
    "@ng-bootstrap/ng-bootstrap": "^17.0.0",
    "@ng-icons/core": "^28.0.0",
    "@ng-icons/tabler-icons": "^28.0.0",
    "@ng-select/ng-select": "^13.3.0",
    "@ngx-formly/bootstrap": "^6.3.5",
    "@ngx-formly/core": "^6.3.5",
    "@nrwl/angular": "19.3.0",
    "@popperjs/core": "^2.11.8",
    "@sentry/angular": "^8.26.0",
    "@sentry/cli": "^2.33.1",
    "amazon-cognito-identity-js": "^6.3.12",
    "aws-jwt-verify": "^4.0.1",
    "axios": "^1.7.7",
    "bootstrap": "^5.3.3",
    "class-transformer": "^0.5.1",
    "class-validator": "^0.14.1",
    "express": "^4.21.1",
    "jwt-decode": "^4.0.0",
    "logrocket": "^8.1.2",
    "mysql2": "^3.10.1",
    "nest-commander": "^3.14.0",
    "nestjs-s3": "^2.0.1",
    "ngx-toastr": "^19.0.0",
    "openai": "^4.68.1",
    "reflect-metadata": "^0.1.13",
    "rxjs": "^7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^10.0.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "~18.0.0",
    "@angular-devkit/core": "~18.0.0",
    "@angular-devkit/schematics": "~18.0.0",
    "@angular-eslint/eslint-plugin": "^18.0.1",
    "@angular-eslint/eslint-plugin-template": "^18.0.1",
    "@angular-eslint/template-parser": "^18.0.1",
    "@angular/cli": "~18.0.0",
    "@angular/compiler-cli": "~18.0.0",
    "@angular/language-service": "~18.0.0",
    "@nestjs/schematics": "^10.0.1",
    "@nestjs/testing": "^10.0.2",
    "@nx/cypress": "19.3.0",
    "@nx/eslint": "19.3.0",
    "@nx/eslint-plugin": "19.3.0",
    "@nx/jest": "19.3.0",
    "@nx/js": "19.3.0",
    "@nx/nest": "19.3.0",
    "@nx/node": "19.3.0",
    "@nx/web": "19.3.0",
    "@nx/webpack": "19.3.0",
    "@nx/workspace": "19.3.0",
    "@schematics/angular": "~18.0.0",
    "@swc-node/register": "~1.9.1",
    "@swc/core": "~1.5.7",
    "@swc/helpers": "~0.5.11",
    "@types/jest": "^29.4.0",
    "@types/multer": "^1.4.12",
    "@types/node": "~18.19.50",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "^7.3.0",
    "@typescript-eslint/parser": "^7.3.0",
    "@typescript-eslint/utils": "^8.0.0-alpha.28",
    "cypress": "^13.8.0",
    "eslint": "~8.57.0",
    "eslint-config-prettier": "^9.0.0",
    "eslint-plugin-cypress": "^2.13.4",
    "jest": "^29.4.1",
    "jest-environment-jsdom": "^29.4.1",
    "jest-environment-node": "^29.4.1",
    "jest-preset-angular": "~14.1.0",
    "nx": "19.3.0",
    "prettier": "^2.6.2",
    "ts-jest": "^29.1.0",
    "ts-node": "10.9.1",
    "typescript": "~5.4.2",
    "webpack-cli": "^5.1.4"
  }
}
